<template>
  <div class="signup bg-gray">
    <b-container>
      <b-row class='mt-2 px-0 py-3'>
        <b-col cols='8' class='mx-auto pt-5'>
          <b-card class='org-session px-4'>
          <b-row class='mt-4 pb-2'>
            <b-col cols="12" class='px-0 text-center'>
              <h4 class="org_title">企業情報</h4>
              <p class="text-center mb-4 text-gray"><small>この情報は、求職者に表示されず、応募者と共有されることはありません</small></p>
              <p v-if='is_error' class="erro">
                入力内容に誤りがあります。<br>
                確認してもう一度入力してください。
              </p>
            </b-col>
          </b-row>

          <b-container>
            <validation-observer class="form" ref="obs">
              <validation-provider name="org_title_name" rules="required">
                <div slot-scope="TitleProps">
                  <b-row >
                    <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>貴社名</h5>

                    <b-form-input v-model="registInfo.name" placeholder=''></b-form-input>
                    <p v-if="TitleProps.failed" class="error">{{ TitleProps.errors[0] }}</p>
                  </b-row>
                </div>
              </validation-provider>

              <validation-provider name="representative_name" rules="required">
                <div slot-scope="RepresentativeNameProps">
                  <b-row class='mt-4'>
                    <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>代表者名</h5>

                    <b-form-input v-model="registInfo.representative_name" placeholder=''></b-form-input>
                    <p v-if="RepresentativeNameProps.failed" class="error">{{ RepresentativeNameProps.errors[0] }}</p>
                  </b-row>
                </div>
              </validation-provider>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>代表者役職</h5>
            </b-row>
            <b-row>
              <b-col class='px-0' cols='6'>
                <validation-provider name="representative_role" rules="required">
                  <div slot-scope="RepresentativeRoleProps">
                    <b-form-input v-model="registInfo.representative_role" placeholder=''></b-form-input>
                    <p v-if="RepresentativeRoleProps.failed" class="error">{{ RepresentativeRoleProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>企業ロゴ画像</h5>
            </b-row>
            <b-row>
              <b-col class='px-0' cols='6'>
                <select-image :imaga_url='registInfo.logo_img' :index='0' :type='"logo"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>郵便番号</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="org_zip" rules="required">
                  <div slot-scope="ZipProps">
                    <b-form-input v-model="registInfo.zip"></b-form-input>
                    <p v-if="ZipProps.failed" class="error text-left">{{ ZipProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5 >都道府県</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="address1" rules="required">
                  <div slot-scope="Address1Props">
                    <b-form-input v-model="registInfo.address1" placeholder=''></b-form-input>
                    <p v-if="Address1Props.failed" class="error text-left">{{ Address1Props.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5 >市区町村</h5>
            </b-row>
            <b-row >
              <b-col class='px-0' cols='12'>
                <validation-provider name="address2" rules="required">
                  <div slot-scope="Address2Props">
                    <b-form-input v-model="registInfo.address2" placeholder=''></b-form-input>
                    <p v-if="Address2Props.failed" class="error">{{ Address2Props.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5 >番地・マンション名</h5>
            </b-row>
            <b-row>
              <b-col class='px-0' cols='12'>
                <validation-provider name="address3" rules="required">
                  <div slot-scope="Address3Props">
                    <b-form-input v-model="registInfo.address3" placeholder=''></b-form-input>
                    <p v-if="Address3Props.failed" class="error">{{ Address3Props.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>電話番号 </h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="phone" rules="required">
                  <div slot-scope="PhoneProps">
                    <b-form-input v-model="registInfo.phone" placeholder=''></b-form-input>
                    <p v-if="PhoneProps.failed" class="error">{{ PhoneProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2 mb-2">{{$t("message.optional")}}</p><h5>FAX</h5>
              <b-form-input v-model="registInfo.fax" placeholder=''></b-form-input>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2 mb-2">{{$t("message.required")}}</p><h5>資本金</h5><br>
            </b-row>
            <b-row >
              <b-col cols='4' class='px-0'>
                <validation-provider name="capital" rules="required">
                  <div slot-scope="CapitalProps">
                    <b-form-input type='number' v-model="registInfo.capital"></b-form-input>
                    <p v-if="CapitalProps.failed" class="error">{{ CapitalProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
              <b-col cols='1' class='mt-2 px-1'>
                万円
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2 mb-2">{{$t("message.required")}}</p><h5>担当者名</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="charge_name" rules="required">
                  <div slot-scope="ChargeNameProps">
                    <b-form-input v-model="registInfo.charge_name" placeholder=''></b-form-input>
                    <p v-if="ChargeNameProps.failed" class="error">{{ ChargeNameProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2 mb-2">{{$t("message.required")}}</p><h5> 担当者役職 </h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="charge_role" rules="required">
                  <div slot-scope="ChargeRoleProps">
                    <b-form-input v-model="registInfo.charge_role" placeholder=''></b-form-input>
                    <p v-if="ChargeRoleProps.failed" class="error">{{ ChargeRoleProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5> 設立 </h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="established_at" rules="required">
                  <div slot-scope="EstablishAtProps">
                    <b-form-input v-model="registInfo.established_at" placeholder=''></b-form-input>
                    <p v-if="EstablishAtProps.failed" class="error">{{ EstablishAtProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5> 法人番号 </h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="corporate_number" rules="required">
                  <div slot-scope="CorporateNumberProps">
                    <b-form-input v-model="registInfo.corporate_number" placeholder=''></b-form-input>
                    <p v-if="CorporateNumberProps.failed" class="error">{{ CorporateNumberProps.errors[0] }}</p>

                    <p><small><a href="https://www.houjin-bangou.nta.go.jp/">法人番号の検索はこちら</a></small></p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>常勤職員数</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="number_fulltime_employees" rules="required">
                  <div slot-scope="FulltimeProps">
                    <b-form-input v-model="registInfo.number_fulltime_employees" placeholder=''></b-form-input>
                    <p v-if="FulltimeProps.failed" class="error">{{ FulltimeProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>事務部員のみ人数</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="number_clerks" rules="required">
                  <div slot-scope="ClerkProps">
                    <b-form-input v-model="registInfo.number_clerks" placeholder=''></b-form-input>
                    <p v-if="ClerkProps.failed" class="error">{{ ClerkProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>現場部員のみ人数</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="number_staff" rules="required">
                  <div slot-scope="StaffProps">
                    <b-form-input v-model="registInfo.number_staff" placeholder=''></b-form-input>
                    <p v-if="StaffProps.failed" class="error">{{ StaffProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>会社HPのURL</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="url" rules="required">
                  <div slot-scope="URLProps">
                    <b-form-input v-model="registInfo.url" placeholder=''></b-form-input>
                    <p v-if="URLProps.failed" class="error">{{ URLProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>



            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>会社概要</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="description" rules="required">
                  <div slot-scope="DescriptionProps">
                    <b-form-input v-model="registInfo.description" placeholder=''></b-form-input>
                    <p v-if="DescriptionProps.failed" class="error">{{ DescriptionProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>過去に外国人人材雇用において<br>不正行為もしくは不正行為に準ずる行為を行なっていないか</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="is_cheating" rules="required">
                  <div slot-scope="IsCheatingProps">
                    <b-form-radio-group
                      v-model="registInfo.is_cheating"
                    >
                      <b-row class='pl-3'>
                        <b-col cols='4' v-for='row in SimpleBoolOptions' :key='row.value' class='pb-3 px-0'>
                          <span class="salary_status_radio pl-2">
                            <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                          </span>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                    <p v-if="IsCheatingProps.failed" class="error">{{ IsCheatingProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>


            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>労働基準法違反の指摘（過去3年<br>※有の場合是正勧告書及び是正報告書の写しを提出   </h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="is_labor_standards_act" rules="required">
                  <div slot-scope="IsLaborProps">

                    <b-form-radio-group
                      v-model="registInfo.is_labor_standards_act"
                    >
                      <b-row class='pl-3'>
                        <b-col cols='4' v-for='row in SimpleBoolOptions' :key='row.value' class='pb-3 px-0'>
                          <span class="salary_status_radio pl-2">
                            <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                          </span>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                    <p v-if="IsLaborProps.failed" class="error">{{ IsLaborProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>保険加入状況</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="insurance_coverage" rules="required">
                  <div slot-scope="InsuraceProps">

                    <b-form-radio-group
                      v-model="registInfo.insurance_coverage"
                    >
                      <b-row class='pl-3'>
                        <b-col cols='4' v-for='row in InsuraceOptions' :key='row.value' class='pb-3 px-0'>
                          <span class="salary_status_radio pl-2">
                            <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                          </span>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>


                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>休日</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="holiday" rules="required">
                  <div slot-scope="HolidayProps">
                    <b-form-input v-model="registInfo.holiday" placeholder=''></b-form-input>
                    <p v-if="HolidayProps.failed" class="error">{{ HolidayProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>給与形態</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="salary_form" rules="required">
                  <div slot-scope="SalaryProps">
                    <b-form-select v-model="registInfo.salary_form" class='dirty' :options="salaryOptions"></b-form-select>
                    <p v-if="SalaryProps.failed" class="error">{{ SalaryProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>特定技能ビザと同程度の技能等を有する日本人を雇用する場合の給与</h5>
            </b-row>
            <b-row>
              <b-col cols='1' class='pl-1 pt-1'>
              </b-col>
              <b-col cols='4' class='px-0'>
                <validation-provider name="similar_japanese_salary" rules="required">
                  <div slot-scope="SimilarProps">
                    <b-form-input type='number' v-model="registInfo.similar_japanese_salary" ></b-form-input>
                    <p v-if="SimilarProps.failed" class="error">{{ SimilarProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
              <b-col cols='1' class='px-1 pt-1'>
                円
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>賃金(締切日)</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='pl-0 pr-3'>
                <validation-provider name="salary_month" rules="required">
                  <div slot-scope="SalaryMonthProps">
                    <b-form-select v-model="salary_month" class='dirty' :options="SalaryMonthOptions"></b-form-select>
                    <p v-if="SalaryMonthProps.failed" class="error">{{ SalaryMonthProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
              <b-col cols='4' class='px-0'>
                <validation-provider name="salary_day" rules="required">
                  <div slot-scope="SalaryDayProps">
                    <b-form-select v-model="salary_day" class='dirty' :options="SalaryDayOptions"></b-form-select>
                    <p v-if="SalaryDayProps.failed" class="error">{{ SalaryDayProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>賃金(支払い方法)</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="salary_way" rules="required">
                  <div slot-scope="WorkLocationProps">
                    <b-form-radio-group
                      v-model="salary_way"
                    >
                      <b-row class='pl-3'>
                        <b-col cols='4' v-for='row in SalaryWayOptions' :key='row.value' class='pb-3 px-0'>
                          <span class="salary_status_radio pl-2">
                            <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                          </span>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                    <p v-if="WorkLocationProps.failed" class="error">{{ WorkLocationProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>給料日</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='px-0'>
                <validation-provider name="overtime" rules="required">
                  <b-form-input type='number' v-model="registInfo.payday" ></b-form-input>
                </validation-provider>
              </b-col>
              <b-col cols='1' class='px-1 pt-1'>
                日
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>勤務形態</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="working_time" rules="required">
                  <div slot-scope="WorkTimeProps">
                    <b-form-radio-group
                      v-model="registInfo.working_time"
                    >
                      <b-row class='pl-3'>
                        <b-col cols='4' v-for='row in workingTimeOptions' :key='row.value' class='pb-3 px-0'>
                          <span class="salary_status_radio pl-2">
                            <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                          </span>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                    <p v-if="WorkTimeProps.failed" class="error">{{ WorkTimeProps.errors[0] }}</p>
                  </div>
                </validation-provider>
                <p><small>主な勤務形態として「固定時間制(通常勤務)」「変形労働時間制」「フレックスタイム制」「みなし労働時間制」「高度プロフェッショナル制度」「シフト制」「宿直勤務制」「管理監督者」などがあります。</small></p>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>月残業時間</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='px-0'>
                約
                <validation-provider name="overtime" rules="required">
                  <div slot-scope="OvertimeProps">
                    <b-form-input type='number' v-model="registInfo.overtime" ></b-form-input>
                    <p v-if="OvertimeProps.failed" class="error">{{ OvertimeProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
              <b-col cols='1' class='px-1 pt-1'>
                時間
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>現在、留学生・技能実習生・特定技能の人材を何名受け入れていますか？</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-textarea rows="6" placeholder="（例）ベトナム人　女性　３名" v-model="registInfo.description"></b-form-textarea>
              </b-col>
            </b-row>

            <b-row class='mt-4 text-center'>
              <b-col cols='5' class='mx-auto'>
                <b-button  pill class='bg-orange' @click='createJob'>この内容で登録</b-button>
              </b-col>
            </b-row>
          </validation-observer>
          </b-container>
        </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import SelectImage from "@/components/SelectImage";
import { mapGetters } from 'vuex';
export default {
  components: { SelectImage },
  data() {
    return {
      registInfo: {},
      is_error: false,
      salary_month: '',
      salary_day: '',
      internal_role:'',
      internal_name: '',
      internal_experience: '',
      instructor_role: '',
      instructor_name: '',
      instructor_experience: '',
      instructor_license: '',
      license_name: '',
      license_date: '',
      salary_way: '',
      SimpleBoolOptions: [
        { value: true, text: 'はい' },
        { value: false, text: 'いいえ' },
      ],
      SimpleBool2Options: [
        { value: true, text: 'ある' },
        { value: false, text: 'なし' },
      ],
      InsuraceOptions: [
        { value: '1', text: '雇用保険' },
        { value: '2', text: '労災'},
        { value: '3', text: '社会保険' },
        { value: '4', text: '厚生年金' },
      ],
      salaryOptions: [
        { value: 'hourt', text: '時給制' },
        { value: 'day', text: '日給制' },
        { value: 'week', text: '週給制'},
        { value: 'month', text: '月給制' },
        { value: 'year', text: '年収制' },
      ],
      SalaryMonthOptions: [
        { value: '1', text: '今月' },
        { value: '2', text: '翌月'},
        { value: '3', text: '翌々月' },
      ],
      SalaryDayOptions: [],
      SalaryWayOptions: [
        { value: '1', text: '現金' },
        { value: '2', text: '振り込み'},
      ],
      workingTimeOptions: [
        { value: '1', text: '週40時間制' },
        { value: '2', text: '会社カレンダーによる'},
        { value: '3', text: '変形労働時間制' },
        { value: '4', text: 'その他' },
      ],
      idToken: localStorage.idToken,
    }
  },
  methods: {
    createJob(){
      this.$refs.obs.validate().then(value =>{
        if(value){
          this.registInfo.payment_details = String(this.salary_month)+ ',' + String(this.salary_day) + ',' + String(this.salary_way)
          this.registInfo.internal_manager = String(this.internal_role)+ ',' + String(this.internal_name) + ',' + String(this.internal_experience)
          this.registInfo.management_instructor = String(this.instructor_role) + ',' + String(this.instructor_name) +' ,' + String(this.instructor_experience) + ',' + String(this.instructor_license) + ',' + String(this.license_name) + ',' + String(this.license_date)


          axios
          .patch(process.env.VUE_APP_API + "/api/org/organizations/" + this.staff.organization_id, {organization: this.registInfo}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            console.log(response.data)
            this.$router.push("/organization/mypage" )
          }).catch(error => {
            console.log('this is org error', error)
          })
          this.is_error = false
        }
        else{
          this.is_error = true
        }
      })
    },
    addImage(data){
      this.registInfo.logo_img = data.image
      this.registInfo = Object.assign({}, this.registInfo)
    }
  },
  async mounted(){
    await this.$store.dispatch("staff/fetchStaff", this.idToken)

    if(this.staff != null){
    console.log(this.staff)
      axios
      .get(process.env.VUE_APP_API + "/api/org/organizations/" + this.staff.organization_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data)
        this.registInfo.payment_details = String(this.salary_month)+ ',' + String(this.salary_day) + ',' + String(this.salary_way)
          this.registInfo.internal_manager = String(this.internal_role)+ ',' + String(this.internal_name) + ',' + String(this.internal_experience)
          this.registInfo.management_instructor = String(this.instructor_role) + ',' + String(this.instructor_name) +' ,' + String(this.instructor_experience) + ',' + String(this.instructor_license) + ',' + String(this.license_name) + ',' + String(this.license_date)

        var payment_details_list = response.data.payment_details.split(',')
        this.salary_month = payment_details_list[0]
        this.salary_day = payment_details_list[1]
        this.salary_way = payment_details_list[2]

        var internal_manager_list = response.data.internal_manager.split(',')
        this.internal_role = internal_manager_list[0]
        this.internal_name = internal_manager_list[1]
        this.internal_experience = internal_manager_list[2]

        var management_instructor_list = response.data.management_instructor.split(',')
        this.instructor_role = management_instructor_list[0]
        this.instructor_name = management_instructor_list[1]
        this.instructor_experience = management_instructor_list[2]
        this.instructor_license = management_instructor_list[3]
        this.license_name = management_instructor_list[4]
        this.license_date = management_instructor_list[5]

        this.registInfo = response.data
      }).catch(error => {
        console.log('this is org error', error)
      })
      this.$store.commit('setLoading', false)
    }
    for (var i = 1; i < 32; i++) {
      this.SalaryDayOptions.push(
        { value: i, text: String(i) + '日'}
      )
    }
  },
  computed: {
    ...mapGetters({
      staff:'staff/getStaff',
    })
  },
  watch: {
    staff: function(){
      axios
      .get(process.env.VUE_APP_API + "/api/org/organizations/" + this.staff.organization_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data)
        this.registInfo = response.data.organization
        var payment_list = (response.data.organization.payment_details || "").split(',')
        var internal_list = (response.data.organization.internal_manager || "").split(',')
        var management_list = (response.data.organization.management_instructor || "").split(',')

        this.salary_month = payment_list[0]
        this.salary_day = payment_list[1]
        this.salary_way = payment_list[2]

        this.internal_role = internal_list[0]
        this.internal_name = internal_list[1]
        this.internal_experience = internal_list[2]

        this.instructor_role = management_list[0]
        this.instructor_name = management_list[1]
        this.instructor_experience = management_list[2]
        this.instructor_license = management_list[3]
        this.license_name = management_list[4]
        this.license_date = management_list[5]
        this.$store.commit('setLoading', false)
      }).catch(error => {
        console.log('this is org error', error)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.border-bottom{
  border-bottom: 1px solid #d6d6d6;
}

.employ_status_radio{
  border: 1px solid #ced4da;
  .custom-radio{
    min-width: 13rem;
  }
}

.salary_status_radio{
  border: 1px solid #ced4da;
  .custom-radio{
    min-width: 10rem;
  }
}

.tag_checkbox{
  border: 1px solid #ced4da;
  .custom-checkbox{
    min-width: 10rem;
  }
}

.org-session{
  border-radius: 1.5rem;
}
</style>
